// extracted by mini-css-extract-plugin
export default {"logoTitle":"jut__LogoTitle__logoTitle","title":"jut__LogoTitle__title","logo":"jut__LogoTitle__logo"};